export default function Demos() {
  const demos = [
    {
      key: 'leads',
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path d="M16 7C12.686 7 10 9.686 10 13C10 16.314 12.686 19 16 19C19.314 19 22 16.314 22 13C22 9.686 19.314 7 16 7Z" stroke="currentColor" strokeWidth="2" />
          <path d="M8 25C8 21.134 11.134 18 15 18H17C20.866 18 24 21.134 24 25" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      ),
      title: 'Recherche de prospects',
      description: 'Identifiez vos prospects idéaux en quelques secondes avec notre base de 200M+ profils.',
      preview: (
        <div className="preview-search">
          <div className="search-bar">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="2" />
              <path d="M11 11L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
            <span>CEO Paris Tech...</span>
          </div>
          <div className="search-results">
            {[0, 0.1, 0.2].map((delay, i) => (
              <div key={i} className="result-item" style={{ animationDelay: `${delay}s` }}>
                <div className="result-avatar"></div>
                <div className="result-info">
                  <div className="result-name"></div>
                  <div className="result-title"></div>
                </div>
                <div className="result-badge">✓</div>
              </div>
            ))}
          </div>
          <div className="search-count">247 prospects trouvés</div>
        </div>
      ),
    },
    {
      key: 'ai',
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path d="M16 4L19 11L26 14L19 17L16 24L13 17L6 14L13 11L16 4Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
        </svg>
      ),
      title: 'Newsletter par IA Générative',
      description: 'Créez du contenu engageant personnalisé automatiquement pour chaque prospect.',
      preview: (
        <div className="preview-email">
          <div className="email-header">
            <div className="email-avatar"></div>
            <div className="email-to">
              <div className="to-label">À:</div>
              <div className="to-name">Marc Dubois</div>
            </div>
          </div>
          <div className="email-body">
            {[0, 0.3, 0.6, 0.9].map((delay, i) => (
              <div key={i} className={`typing-line ${i === 2 ? 'short' : ''}`} style={{ animationDelay: `${delay}s` }}></div>
            ))}
          </div>
          <div className="ai-badge">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M6 1L7.5 4.5L11 6L7.5 7.5L6 11L4.5 7.5L1 6L4.5 4.5L6 1Z" fill="currentColor" />
            </svg>
            Généré par IA
          </div>
        </div>
      ),
    },
    {
      key: 'sequences',
      icon: (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <circle cx="8" cy="16" r="3" stroke="currentColor" strokeWidth="2" />
          <circle cx="16" cy="16" r="3" stroke="currentColor" strokeWidth="2" />
          <circle cx="24" cy="16" r="3" stroke="currentColor" strokeWidth="2" />
          <path d="M11 16H13M19 16H21" stroke="currentColor" strokeWidth="2" />
        </svg>
      ),
      title: 'Séquences automatisées',
      description: 'Orchestrez vos campagnes email, LinkedIn et SMS dans une seule séquence.',
      preview: (
        <div className="preview-sequence">
          {[
            { icon: '✉', class: 'email', delay: 0 },
            { icon: 'in', class: 'linkedin', delay: 0.5 },
            { icon: '💬', class: 'sms', delay: 1 },
            { icon: '✉', class: 'email', delay: 1.5 },
          ].map((step, i) => (
            <div key={i} className="sequence-step" style={{ animationDelay: `${step.delay}s` }}>
              <div className={`step-icon ${step.class}`}>{step.icon}</div>
              {i < 3 && <div className="step-line"></div>}
            </div>
          ))}
        </div>
      ),
    },
  ]

  return (
    <div className="demos-section">
      <div className="container">
        <div className="section-header">
          <div className="demos-label">DÉMONSTRATIONS</div>
          <h2>Voyez Jean-Louis en action</h2>
          <p className="section-description">Des fonctionnalités puissantes, visualisées en temps réel</p>
        </div>

        <div className="demos-showcase">
          {demos.map((demo) => (
            <div key={demo.key} className="demo-card-3d" data-demo={demo.key}>
              <div className="demo-card-inner">
                <div className="demo-preview">{demo.preview}</div>
                <div className="demo-content">
                  <div className="demo-icon">{demo.icon}</div>
                  <h3>{demo.title}</h3>
                  <p>{demo.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
